import { action, observable } from 'mobx';
import { uuid } from '../../utils';
import { useRootStore } from '../index';
import { GoogleAssetsEntities } from 'pages/Article/components/GoogleCampaignArticle/components/GoogleAssetsBuilder/constants';

type TextAsset = { id: string; text: string };
type TabAssets = {
  [GoogleAssetsEntities.Headlines]: TextAsset[];
  [GoogleAssetsEntities.Descriptions]: TextAsset[];
  [GoogleAssetsEntities.ShortHeadlines]: TextAsset[];
  [GoogleAssetsEntities.LongHeadlines]: TextAsset[];
};

export class GoogleAssetsTextsStore {
  @observable tabAssets: TabAssets = {
    [GoogleAssetsEntities.Headlines]: new Array(5).fill(null).map(() => ({ id: uuid(), text: '' })),
    [GoogleAssetsEntities.Descriptions]: new Array(5).fill(null).map(() => ({ id: uuid(), text: '' })),
    [GoogleAssetsEntities.ShortHeadlines]: new Array(5).fill(null).map(() => ({ id: uuid(), text: '' })),
    [GoogleAssetsEntities.LongHeadlines]: new Array(5).fill(null).map(() => ({ id: uuid(), text: '' }))
  };

  @action setTabAssets = (assets: TabAssets) => (this.tabAssets = assets);
}

export const useGoogleAssetsTextsStore = (): GoogleAssetsTextsStore => {
  const store = useRootStore();
  if (!store.googleAssetsTextsStore) throw new Error('Google Assets Builder store has not been initialized');
  return store.googleAssetsTextsStore;
};
